import type {StyleRules} from '@material-ui/core/styles/withStyles'

export const styles = (theme): StyleRules => ({
  time: {
    fontWeight: 'bold',
    fontSize: '22px',
    [theme.breakpoints.down('xs')]: {
      fontSize: '18px',
    },
  },
})
